import { merge } from 'lodash';

export function makeLineOption(op, unit) {
  return merge(op, {
    textStyle: {
      color: '#04a4bc'
    },
    tooltip: {
      trigger: 'axis'
    },
    dataZoom: [{ type: 'inside' }],
    backgroundColor: '#121e2c',
    legend: {
      top: 10,
      right: 10,
      textStyle: {
        color: '#04a4bc'
      }
    },
    grid: {
      top: 70,
      bottom: 30,
      left: 25,
      right: 35,
      containLabel: true
    },
    xAxis: {
      type: 'time',
      axisLine: {
        lineStyle: {
          color: '#172749'
        }
      },
      axisLabel: {
        fontSize: '90%'
      },
      splitLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'value',
      name: unit,
      nameGap: 32,
      axisLine: { show: false },
      splitLine: {
        lineStyle: {
          color: '#172749'
        }
      },
      axisLabel: {
        fontSize: '90%'
      },
      max(v) {
        if (v.max < 0) {
          return v.max / 2;
        }
        if (v.max == 0) {
          return v.max + 0.0001;
        }
        return v.max < 100 ? 2 * v.max : v.max + 100;
      }
    },
    series: op.series.map(() => ({
      type: 'line',
      smooth: true,
      symbol: 'circle'
    }))
  });
}
